import React from 'react';

import cx from 'classnames';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import { Tooltip } from 'react-tooltip';

import styles from './CouponActionButton.module.scss';

export const CouponActionButton = ({
  onClick,
  imgSrc,
  labeltext,
  inactive,
  tooltip = '',
}) => {
  const tooltipId = `coupon-action-tooltip-${labeltext.replace(/\s+/g, '-').toLowerCase()}`;

  const button = (
    <div
      styleName={cx('coupon-action-section', {
        disabled: inactive,
        'icon-only': !labeltext,
      })}
    >
      <img
        onClick={!inactive ? onClick : undefined}
        styleName="coupon-action-btn"
        alt={labeltext || ''}
        src={imgSrc}
      />
      {labeltext && <span className="ml-2">{labeltext}</span>}
    </div>
  );

  if (!tooltip) {
    return button;
  }

  return (
    <>
      <span
        data-tooltip-id={tooltipId}
        data-tooltip-content={tooltip}
        style={{ display: 'inline-block' }}
      >
        {button}
      </span>

      <Tooltip
        id={tooltipId}
        place="top"
      />
    </>
  );
};

CouponActionButton.propTypes = {
  onClick: PropTypes.func,
  imgSrc: PropTypes.string,
  labeltext: PropTypes.string,
  inactive: PropTypes.bool,
  tooltip: PropTypes.string,
};

export default CSSModules(CouponActionButton, styles, {
  allowMultiple: true,
});
